import React from 'react'

import View from '../../../../../components/pdf/View'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import Line from '../../../../../components/pdf/Line'
import { TableHeadText } from '../../../../../components/pdf/TableHelpers'
import { useFormReply } from '../../_load/FormReplyLoader'
import {
  findReplyByQuestionId,
  getReplyValue,
  statePreposition,
  toDateFormat,
  formatCNPJ
} from '../../_helpers/pdfHelpers'

const HRHContent = () => {
  const { replies } = useFormReply()

  const businessName = getReplyValue(findReplyByQuestionId(replies, 1))
  const corporateType = getReplyValue(findReplyByQuestionId(replies, 119))
  const cnpj = formatCNPJ(getReplyValue(findReplyByQuestionId(replies, 120)))
  const address = getReplyValue(findReplyByQuestionId(replies, 4))
  const postalCode = getReplyValue(findReplyByQuestionId(replies, 66))
  const legalRepresentativeName = getReplyValue(findReplyByQuestionId(replies, 12))
  const nationality = getReplyValue(findReplyByQuestionId(replies, 48))
  const maritalStatus = getReplyValue(findReplyByQuestionId(replies, 13))
  const rg = getReplyValue(findReplyByQuestionId(replies, 125))
  const cpf = getReplyValue(findReplyByQuestionId(replies, 17))
  const legalRepresentativeEmail = getReplyValue(findReplyByQuestionId(replies, 28))
  const financial = getReplyValue(findReplyByQuestionId(replies, 130))
  const begginingDuration = toDateFormat(getReplyValue(findReplyByQuestionId(replies, 68)), 'D [de] MMMM [de] YYYY')
  const service = getReplyValue(findReplyByQuestionId(replies, 45))
  const city = getReplyValue(findReplyByQuestionId(replies, 67))
  const now = toDateFormat(new Date(), 'D [de] MMMM [de] YYYY')

  return (
    <View pageBreakAfter>
      <Table justify="space-between" center width={'100%'}>
        <TableRow style={{ align: 'center' }}>
          <TableHeadText align={'center'}>CONTRATO DE PRESTAÇÃO DE SERVIÇOS</TableHeadText>
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Text size="small" align="justify">
        Pelo presente instrumento particular, as Partes, denominadas individualmente <b>"Parte"</b> e, em conjunto,
        <b> "Partes"</b>:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        de um lado, <b>VENTURE CAPITAL PARTICIPACOES E INVESTIMENTOS S/A</b>, sociedade anônima de capital fechado, com
        foro na cidade de Fortaleza, Estado do Ceará, na Avenida Desembargador Moreira, nº 1080, Bairro Aldeota, CEP
        60.170-002, inscrita no CNPJ/MF sob o nº 24.241.659/0002-89, inscrição municipal nº 502588-5, neste ato
        representada na forma do seu estatuto social, doravante designada apenas como <b>CONTRATANTE</b>;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        e do outro lado, <b> {businessName} </b>, {corporateType.name}, estabelecida na {address.address}, Bairro{' '}
        {address.neighborhood}, na Cidade de {address.city}, Estado {statePreposition(address.state)} {address.state},
        CEP {postalCode}, inscrita no CNPJ/MF sob o nº {cnpj}, neste ato representada na forma do seu contrato social
        vigente por <b>{legalRepresentativeName}</b>, {nationality}, {maritalStatus.name}, portador da carteira de
        identidade RG nº {rg}, inscrito no CPF/MF sob o nº {cpf}, correio eletrônico {legalRepresentativeEmail}, com
        domicílio comercial no endereço da pessoa jurídica acima qualificada, doravante designada apenas como{' '}
        <b>"CONTRATADA"</b>.
      </Text>
      <Separator weight={4} />
      <Text bold size="small">
        PRELIMINARMENTE – QUADRO RESUMO
      </Text>
      <Separator weight={4} />
      <Table justify="space-between" center width={'100%'}>
        <TableRow style={{ align: 'center' }}>
          <TableHeadText align={'center'}>CLÁUSULA</TableHeadText>
          <TableHeadText align={'center'}>PREVISÃO</TableHeadText>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 1ª – Objeto</Text>
          </TableCol>
          <TableCol>
            <Text size="small">Serviços especializados de {service}</Text>
          </TableCol>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 2ª – Local</Text>
          </TableCol>
          <TableCol>
            <Text size="small">
              {city} e/ou em outras localidades designadas pela <b>CONTRATANTE</b>{' '}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 3ª – Preço</Text>
          </TableCol>
          <TableCol>
            <Text size="small">{financial} fixo mensal</Text>
          </TableCol>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 6ª – Prazo e vigência</Text>
          </TableCol>
          <TableCol>
            <Text size="small">
              Prazo de 12 meses, prorrogável por períodos sucessivos de 12 meses <br />
              Vigência a partir de {begginingDuration}
            </Text>
          </TableCol>
        </TableRow>
        <TableRow>
          <TableCol>
            <Text size="small">Cláusula 12 – Foro</Text>
          </TableCol>
          <TableCol>
            <Text size="small">Comarca de Fortaleza (CE)</Text>
          </TableCol>
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Text size="small" align="justify">
        Pelo presente instrumento e na melhor forma de direito, as partes acima qualificadas têm, entre si, justo e
        acertado o presente
        <b>
          <i> Contrato de Prestação de Serviços</i>
        </b>
        , o qual se regerá pelas seguintes cláusulas:
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 1ª - DO OBJETO
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>1.</b> O objeto do presente contrato é a prestação pela <b>CONTRATADA</b> à <b>CONTRATANTE</b>, de serviços
        especializados de {service}, no âmbito das atividades da <b>CONTRATANTE</b>, notadamente em seus negócios de
        gestão de condomínios e gestão operacional de negócios imobiliários.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>1.1</b> A <b>CONTRATADA</b>, por si, seus empregados ou prepostos, sob as penas da lei, manterá, em qualquer
        tempo, inclusive após a extinção deste instrumento, o mais completo e absoluto sigilo a respeito de quaisquer
        dados, materiais, pormenores, informações, documentos, especificações técnicas e comerciais de produtos da{' '}
        <b>CONTRATANTE</b> ou de terceiros, que serão considerados como informações confidenciais, e que venha a ter
        conhecimento ou acesso, ou que lhe venham a ser confiados, sejam relacionadas ou não com este instrumento, em
        estrita concordância com os princípios norteadores da Lei Geral de Proteção de Dados Pessoais (LGPD) – Lei nº
        13.709, sob pena de recair nas suas penalidades.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 2ª – DO LOCAL DA PRESTAÇÃO DOS SERVIÇOS
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>2.</b> Fica acordado que os serviços serão prestados em instalações disponibilizadas pela <b>CONTRATANTE</b>,
        sejam próprias ou terceirizadas, na Cidade de {city} e/ou em outras localidades que vierem a ser designadas pela{' '}
        <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>2.1.</b> Despesas de viagem a serviço, quando necessárias e previamente autorizadas, por escrito, serão
        arcadas pela <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 3ª – DO PREÇO E FORMA DE PAGAMENTO
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>3.</b> Pela prestação dos serviços ora contratados, a <b>CONTRATANTE</b> pagará à <b>CONTRATADA</b>, o valor
        fixo mensal de {financial}, mediante a emissão de Nota Fiscal.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>3.1.</b> Os pagamentos à <b>CONTRATADA</b> serão efetuados pela <b>CONTRATANTE</b> no 5º (quinto) dia útil do
        mês subsequente ao mês da prestação dos serviços, mediante a emissão de nota fiscal que deverá ser entregue para
        a <b>CONTRATADA</b> com antecedência mínima de 5 (cinco) dias.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>3.2.</b> Constitui obrigação exclusiva da <b>CONTRATADA</b> o pagamento de todos os impostos e contribuições
        incidentes em suas notas fiscais de serviços; não cabendo, portanto, qualquer responsabilidade sob esse aspecto
        à <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 4ª – DAS OBRIGAÇÕES DA CONTRATANTE
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>4.</b> Acordam as partes que faz parte das obrigações da <b>CONTRATANTE</b>, sem prejuízo das demais
        previstas neste instrumento:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>a)</b> Realizar o pagamento pelos serviços prestados pela <b>CONTRATADA</b>, conforme estabelecido na
        Cláusula 3ª supra; e
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>b)</b> Fornecer à <b>CONTRATADA</b> as informações necessárias para o regular desenvolvimento de suas
        atividades, especificando os detalhes necessários à perfeita execução dos serviços ora contratados.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 5ª – DAS OBRIGAÇÕES DA CONTRATADA
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>5.</b> Acordam as partes que faz parte das obrigações da <b>CONTRATADA</b>, sem prejuízo das demais previstas
        neste instrumento:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>a)</b> O cumprimento, integral, do objeto do presente contrato, nos termos estabelecidos da Cláusula 1ª;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>b)</b> Agir com responsabilidade, zelo, ética e presteza, no desempenho do serviço contratado;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>c)</b> Utilizar as técnicas e orientações/treinamentos disponibilizados pela <b>CONTRATANTE</b> para a
        realização das atividades objeto deste contrato, empregando seus melhores esforços para a consecução dos objetos
        aqui previstos; e
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>d)</b> Recolher os tributos e contribuições previdenciárias incidentes sobre as Notas Fiscais de Serviço
        emitidas.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 6ª – DO PRAZO E DA RESCISÃO
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>6.</b> O presente Contrato é celebrado pelo prazo de 12 (doze) meses, iniciando sua vigência em{' '}
        {begginingDuration}, sendo prorrogado, automaticamente, por períodos sucessivos de 12 (doze) meses, exceto se de
        outra forma for acordado entre as Partes.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>6.1.</b> O presente instrumento poderá ser rescindido, a qualquer tempo, por qualquer das partes:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>a)</b> De imediato, se dentro dos primeiros 2 (dois) meses da prestação de serviços;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b> b)</b> Após os primeiros 2 (dois) meses da prestação de serviços, mediante manifestação, por escrito, da
        parte interessada com 30 (trinta) dias de antecedência.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>6.1.1.</b> Poderá ainda a rescisão ser operada, de pleno direito, diante do descumprimento das obrigações
        contratuais contraídas, por qualquer das partes, sendo que, neste caso, a comunicação expressa da parte
        prejudicada será feita com 10 (dez) dias de antecedência.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>6.2.</b> Em qualquer hipótese de rescisão, por quaisquer das Partes, as obrigações da <b>CONTRATANTE</b>{' '}
        sobreviverão e a <b>CONTRATADA</b> fará jus ao recebimento de todas as remunerações, proporcionalmente ao
        período e aos serviços efetivamente prestados à <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 7ª – DOS DIREITOS À PROPRIEDADE
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>7.</b> Todos os resultados oriundos da prestação de serviço ora <b>CONTRATADA</b> são, e sempre serão, de
        propriedade exclusiva da <b>CONTRATANTE</b>, não podendo, em hipótese alguma, a <b>CONTRATADA</b> se apoderar ou
        se utilizar dos dados, informações ou cadastro dos clientes, sob pena de responder por indenização em favor da{' '}
        <b>CONTRATANTE</b>, por lucros cessantes, e perdas e danos, conforme legislação em vigor.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>7.1.</b> Resta acordado que a equipe envolvida na prestação dos serviços ora contratados, se compromete em
        manter sigilo sobre todos os dados e informações a que tenha acesso, em virtude do cumprimento do objeto do
        presente contrato, sob pena de referida quebra de sigilo ser considerada infração contratual, implicando a{' '}
        <b>CONTRATADA</b> nas penas previstas em lei, inclusive indenização à <b>CONTRATANTE</b>, por lucro cessante, e
        perdas e danos.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 8ª – DA CONFIDENCIALIDADE
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>8.</b> Todas as informações pertencentes ou relacionadas à <b>CONTRATANTE</b>, acessadas por força deste
        Instrumento, são consideradas “Informações Confidenciais”. Deste modo, a <b>CONTRATADA</b> obriga-se, por si e
        por terceiros por ela eventualmente contratados, a manter sigilo sobre todas as informações e dados a que tiver
        acesso e que sejam reveladas pela <b>CONTRATANTE</b>, bem como a limitar a análise à exploração de oportunidades
        dentro do âmbito do negócio pretendido.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>8.1.</b> Para os fins do presente Instrumento, o termo “Informações Confidenciais” significará todas as
        informações não públicas, sejam elas escritas, ou por meio de imagens, que sejam reveladas ou disponibilizadas
        diretamente pela <b>CONTRATANTE</b>.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b> 8.2.</b> A <b>CONTRATADA</b> deverá devolver à <b>CONTRATANTE</b> os meios de suporte de Informações
        Confidenciais que por esta última lhe forem disponibilizados a qualquer título no âmbito e para fins da
        realização do objeto deste contrato, nas seguintes hipóteses:
        <ul style={{ listStyleType: 'none' }}>
          <li>
            <b>(i)</b> sempre que solicitado, no prazo de até 72 (setenta e duas) horas contadas da respectiva
            solicitação; ou
          </li>
          <li>
            <b>(ii)</b> sempre que os citados meios deixarem de ser necessários à Análise, observado que em ambas as
            hipóteses não deverá ser retida pela Parte nenhuma cópia e/ou reprodução das Informações Confidenciais
            objetivadas.
          </li>
        </ul>
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>8.3.</b> A <b>CONTRATADA</b> protegerá as Informações Confidenciais recebidas da <b>CONTRATANTE</b>, bem como
        os respectivos meios de suporte, com um máximo padrão de proteção adequado, vinculando todas as pessoas
        envolvidas na utilização dessas informações, que deverão guardar e respeitar, de igual modo, essa proteção, sem
        prejuízo de quaisquer das condições de sigilo estabelecidas neste Termo.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>8.4.</b> Estão abrangidos e obrigados à proteção supracitada, pela <b>CONTRATADA</b>, os seus dirigentes,
        administradores, empregados, agentes, contratados e quaisquer outras pessoas vinculadas ou relacionadas à mesma,
        que tenham ou possam ter acesso às Informações Confidenciais ou aos respectivos meios de suporte da informação.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>8.5.</b> O fornecimento de Informações Confidenciais da <b>CONTRATANTE</b> à <b>CONTRATADA</b>:
        <ul style={{ listStyleType: 'none' }}>
          <li>
            <b>(i)</b> não implica em renúncia ou transferência de nenhum direito, já obtido ou potencial, associado a
            tais informações, que permanecem como de propriedade da <b>CONTRATANTE</b> que disponibilizou tais
            Informações Confidenciais para os fins previstos neste contrato;
          </li>
          <li>
            <b>(ii)</b> não obriga a <b>CONTRATANTE</b> a celebrar qualquer acordo definitivo com relação ao Negócio
            Pretendido; e
          </li>
          <li>
            <b>(iii)</b> não estabelece qualquer vínculo, direito de preferência e/ou exclusividade da <b>CONTRATADA</b>{' '}
            com relação à <b>CONTRATANTE</b>, mas, tão somente, a obrigação de confidencialidade expressamente
            estipulada neste instrumento.
          </li>
        </ul>
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>8.6.</b> A não observância de qualquer das disposições estabelecidas nesta Cláusula sujeitará a{' '}
        <b>CONTRATADA</b> às medidas extrajudiciais e judiciais cabíveis, a qual ficará responsável por indenizar a{' '}
        <b>CONTRATANTE</b> prejudicada, no valor das perdas e danos e lucros cessantes eventualmente causados pela
        infração que tenha sido cometida; cumulativamente, sujeitará, ainda a <b>CONTRATADA</b> a multa por
        descumprimento, no valor de R$ 30.000,00 (trinta mil reais).
      </Text>
      <Separator weight={8} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 9ª – DA PROTEÇÃO DE DADOS PESSOAIS
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.</b> A <b>CONTRATANTE</b> e a <b>CONTRATADA</b> se comprometem a proteger os direitos fundamentais de
        liberdade e de privacidade e o livre desenvolvimento da personalidade da pessoa natural, relativos ao tratamento
        de dados pessoais, inclusive nos meios digitais, em total observância à Lei 13.709/2018, denominada Lei Geral de
        Proteção de Dados, doravante LGPD.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.</b> Utilizando a definição legal de dado pessoal e dado pessoal sensível constante no artigo 5º, incisos
        I e II, da LGPD, fica ajustado que ambas as PARTES se comprometem a garantir que o tratamento dos dados pessoais
        será sempre realizado:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b> 9.1.1</b> com fundamento em uma das bases legais elencadas nos artigos 7º e/ou 11 da LGPD;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.2</b> para o atendimento de propósitos específicos, legítimos, explícitos e informados ao titular dos
        dados pessoais;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.3</b> de forma limitada ao desenvolvimento das atividades estritamente necessárias ao atingimento das
        finalidades envolvidas na execução do presente contrato, utilizando os dados pessoais, quando cabível, no limite
        do cumprimento das obrigações legais e/ou regulatórias envolvidas, no exercício regular de direito, por
        determinação judicial ou por requisição da ANPD (Autoridade Nacional de Proteção de Dados);
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.4</b> com a obtenção do consentimento do titular dos dados pessoais, na hipótese em que for inviável o
        tratamento dos dados pessoais com fundamento em quaisquer outras bases legais previstas nos artigos 7º e/ou 11
        da LGPD;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.5</b> de forma limitada à execução dos serviços descritos neste contrato, e em hipótese alguma poderão
        ser compartilhados ou utilizados para outros fins, autorizando-se o compartilhamento de forma excepcional apenas
        no caso em que tal medida mostre-se indispensável ao cumprimento deste contrato e garantindo-se sempre que o
        TERCEIRO se comprometa a observar a LGPD, cabendo à PARTE que compartilhou os dados pessoais com TERCEIROS
        informar tal circunstância à outra PARTE;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.6</b> com base em sistemas computacionais atualizados e adequados, de modo que os sistemas que servirão
        de base para armazenamento dos dados pessoais coletados, necessariamente, seguirão um conjunto de premissas,
        políticas e especificações técnicas de elevado nível de conformidade à da ISO 27001, assim entendido como o
        padrão para sistema de gestão da segurança da informação, publicado em outubro de 2005 pelo{' '}
        <i>International Organization for Standardization</i> e pelo <i>International Electrotechnical Commission;</i>
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.7</b> de forma segura, de modo que os dados obtidos em razão desse contrato serão armazenados em um banco
        de dados seguro, com garantia de registro das transações realizadas na aplicação de acesso (<i>log</i>) e
        adequado controle de acesso baseado em função (<i>role based access control</i>) e com transparente
        identificação do perfil dos credenciados, tudo estabelecido como forma de garantir inclusive a rastreabilidade
        de cada transação e a franca apuração, a qualquer momento, de desvios e falhas, vedado o compartilhamento desses
        dados com TERCEIROS, autorizando-se o compartilhamento de forma excepcional apenas no caso em que tal medida
        mostre-se indispensável ao cumprimento deste contrato e garantindo-se sempre que o TERCEIRO comprometa-se a
        observar a LGPD, cabendo à PARTE que compartilhou os dados pessoais com TERCEIROS informar tal circunstância à
        outra PARTE;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.1.8</b> de maneira limitada à vigência deste contrato e respeitadas as normas setoriais e regulatórias de
        regência relativas ao armazenamento posterior de dados pessoais, de modo que, uma vez encerrada a vigência do
        contrato ou não havendo mais necessidade de utilização dos dados pessoais, sejam eles sensíveis ou não, ambas as
        PARTES interromperão o tratamento dos Dados Pessoais disponibilizados, em no máximo (30) dias, eliminará ou
        anonimizando completamente os Dados Pessoais e todas as cópias porventura existentes (seja em formato digital ou
        físico), salvo quando alguma das Partes tenha que manter os dados para cumprimento de obrigação legal ou outra
        hipótese da LGPD.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b> 9.2.</b> O eventual acesso, por quaisquer das PARTES, às bases de dados que contenham ou possam conter dados
        pessoais ou segredos de negócio implicará para a outra PARTE e para seus prepostos ou colaboradores, o absoluto
        dever de sigilo, no curso do presente contrato e pelo mesmo prazo estipulado para vigência do contrato;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.3.</b> Ambas as PARTES cooperarão no cumprimento das obrigações referentes ao exercício dos direitos dos
        Titulares previstos na LGPD e nas Leis e Regulamentos de Proteção de Dados em vigor e também no atendimento de
        requisições e determinações do Poder Judiciário, Ministério Público, Órgãos de controle administrativo;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.4.</b> Ambas as PARTES se comprometem a informar-se mutuamente quando do recebimento de qualquer
        solicitação de um Titular de Dados, a respeito dos seus Dados Pessoais, comprometendo-se, ainda, a abster-se de
        responder qualquer solicitação em relação aos Dados Pessoais do referido solicitante antes de comunicar
        formalmente a outra PARTE;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.5.</b> O “ENCARREGADO” ou “DPO” (<i>Data Protection Officer</i>) da <b>CONTRATADA</b> manterá contato
        formal com o “Encarregado” ou “DPO” da <b>CONTRATANTE</b>, no prazo de 24 (vinte e quatro) horas da ocorrência
        de qualquer incidente que implique violação ou risco de violação de dados pessoais, para que ambas as PARTES
        possam adotar as providências devidas, na hipótese de questionamento das autoridades competentes;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.6.</b> A título de decisão conjunta dos “Encarregados” de proteção de dados ou “DPO” de ambas as PARTES, a{' '}
        <b>CONTRATANTE</b> e a <b>CONTRATADA</b> poderão ser provocadas a colaborar na elaboração do relatório de
        impacto (DPIA), conforme a sensibilidade e o risco inerente dos serviços objeto deste contrato, no tocante a
        dados pessoais;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.7.</b> As Partes deverão envidar seus melhores esforços para evitar o vazamento de dados, o desvio na
        finalidade original do tratamento dos dados, a violação dos direitos dos titulares além das demais disposições
        da LGPD:
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.7.1.</b> Considera-se vazamento de dados, aquele que por dolo ou culpa não tenha empregado os melhores
        esforços e práticas para tratar adequadamente dados pessoais e/ou dados pessoais sensíveis, os quais acabam por
        ser compartilhados com pessoas não autorizadas;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.7.2.</b> Considera-se desvio da finalidade original do tratamento dos dados, aquele que utilize os dados
        para atividade alheia àquela descrita na Cláusula 1ª.
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b> 9.8.</b> Na hipótese de proposição de processo judicial e/ou processo administrativo envolvendo a violação
        de dados pessoais, deve a PARTE intimada notificar a outra PARTE imediatamente sob a existência de referido
        processo para que as medidas cabíveis possam ser tomadas;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.9.</b> Ambas as PARTES se comprometem a facilitar o acesso dos dados pessoais do respectivo titular para
        fins de atualização, correção, bloqueio ou eliminação, revogação de consentimento, bem como esclarecimentos
        acerca dos cargos e funções que possuem acesso aos dados e sobre a existência de políticas e práticas para
        aplicação da LGPD;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.10.</b> Eventuais responsabilidades das PARTES envolvendo questões relacionadas à violação à LGPD, serão
        apuradas conforme estabelecido na Seção III, Capítulo VI da LGPD;
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>9.11.</b> <b>CONTRATANTE</b> e <b>CONTRATADA</b> se comprometem a informar, mutuamente, no prazo de 30
        (trinta) dias da assinatura do presente instrumento contratual, os dados de contato do seu “ENCARREGADO” de
        proteção de dados, também denominado “DPO” (<i>Data Protection Officer</i>).
      </Text>
      <Separator weight={8} />
      <Text size="small" bold underlineColor>
        CLÁUSULA 10ª – DA VALIDADE DO CONTRATO ELETRÔNICO
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>10.</b> As Partes reconhecem a veracidade, autenticidade, integridade, validade e eficácia deste Contrato e
        seus termos, nos moldes do art. 219 do Código Civil, bem como a aposição das respectivas assinaturas eletrônicas
        neste Contrato, na plataforma de Certificação D4Sign{' '}
        <a href="https://www.d4sign.com.br/">https://www.d4sign.com.br/</a>
      </Text>
      <Separator weight={4} />
      <Text size="small" align="justify">
        <b>10.1.</b> Por fim, as Partes responsabilizam-se direta e ilimitadamente pelas informações prestadas a
        respeito de suas representações legais, atestando que as pessoas informadas para a emissão de assinatura
        eletrônica na plataforma de Certificação D4Sign são legitimadas e possuem poderes expressos para celebrar este
        Contrato.
      </Text>
      <Separator weight={4} />
      <Text size="small" bold>
        <Text size="small" bold underlineColor>
          CLÁUSULA 11 – DAS DISPOSIÇÕES GERAIS
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          <b>11.</b> Não existe nenhum tipo de vínculo empregatício entre a <b>CONTRATANTE</b> e os empregados da{' '}
          <b>CONTRATADA</b>, não sendo a <b>CONTRATANTE</b> responsável por quaisquer obrigações trabalhistas em nome da{' '}
          <b>CONTRATADA</b>. Desta forma, fica expressamente estipulada a isenção da <b>CONTRATANTE</b> por quaisquer
          encargos trabalhistas, securitários e previdenciários, que vierem a incidir, bem como, pela infortunística e
          eventuais acidentes de trabalho relacionados com o pessoal da <b>CONTRATADA</b> a serviço da{' '}
          <b>CONTRATANTE</b>, ficando sob a exclusiva responsabilidade da <b>CONTRATADA</b>, assumir qualquer demanda a
          esse título, que vier a ser proposta por seus respectivos empregados.
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          <b> 11.1.</b> Os tributos (impostos, taxas, contribuições sociais, trabalhistas e fiscais) que sejam devidos
          em decorrência da atividade da <b>CONTRATADA</b> são de sua exclusiva responsabilidade. A <b>CONTRATANTE</b>,
          quando fonte retentora, deverá descontar e recolher, nos prazos da Lei, dos pagamentos que efetuar, os
          tributos a que esteja obrigada pela legislação vigente.
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          <b>11.2.</b> As partes, por meio deste instrumento, concordam em não utilizar, de modo ou em tempo algum, o
          nome da outra parte ou o nome de uma de suas afiliadas ou subsidiárias, nem o logotipo ou o símbolo comercial
          usado pela outra parte ou de uma de suas afiliadas ou subsidiárias, restando suas marcas devidamente
          respeitadas e protegidas, até mesmo em papéis timbrados, envelopes, circulares, avisos, anúncios ou qualquer
          outro propósito que possa sugerir a existência de vínculo ou associação com a outra parte, suas afiliadas ou
          subsidiárias, sem prévia e expressa autorização da outra parte.{' '}
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          <b>11.3.</b> Eventual aceitação por uma das Partes da não execução, pela outra, de qualquer das cláusulas ou
          condições deste contrato, a qualquer tempo, deverá ser interpretada como mera liberalidade, não implicando,
          portanto, a desistência de exigir o cumprimento das disposições aqui contidas ou o direito de pleitear
          futuramente, a execução total de cada uma das obrigações.{' '}
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          <b>11.4.</b> A <b>CONTRATADA</b> obriga-se a executar os serviços contratados, de acordo com as leis e
          exigências emanadas das autoridades Federal, Estadual e Municipal, isentando a <b>CONTRATANTE</b> de qualquer
          responsabilidade pela falta do cumprimento destas Leis e exigências.{' '}
        </Text>
        <Separator weight={4} />
        <Text size="small" bold underlineColor>
          CLÁUSULA 12 – DO FORO
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          <b>12.</b> As Partes elegem o Foro da Comarca de Fortaleza, Estado do Ceará, como único competente para
          dirimir dúvidas e resolver eventuais controvérsias resultantes da aplicação do presente Contrato, com expressa
          renúncia a qualquer outro, por mais privilegiado que seja.
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          O presente instrumento poderá ser firmado através de assinatura eletrônica, devidamente regulamentada pela
          Medida Provisória 2.200-2/2001, com a qual as partes declaram ciência e concordância.
        </Text>
        <Separator weight={4} />
        <Text size="small" align="justify">
          E por estarem assim, justas e contratadas, as Partes assinam o presente instrumento, na presença de 2 (duas)
          testemunhas que também o assinam, para que produza seus jurídicos e legais efeitos.
        </Text>
      </Text>
      <Separator weight={4} />
      <Table center color={'transparent'} justify="center">
        <TableRow color={'transparent'} style={{ align: 'center' }} width={'100%'}>
          <Text size="small" align="justify">
            Fortaleza (CE), {now}.
          </Text>
        </TableRow>
      </Table>
      <Separator weight={4} />
      <Text size="small" bold>
        PELA CONTRATANTE:
      </Text>

      <Separator weight={8} />

      <Line color={'black'} />
      <Table center color={'transparent'} justify="center">
        <TableRow color={'transparent'} style={{ align: 'center' }} width={'100%'}>
          <Text size="small" bold align={'center'}>
            VENTURE CAPITAL PARTICIPAÇÕES E INVESTIMENTOS S/A
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" align={'center'}>
            CNPJ/MF sob o nº 24.241.659/0002-89
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" italic align={'center'}>
            (Assinado eletronicamente)
          </Text>
        </TableRow>
      </Table>

      <Separator weight={8} />

      <Text size="small" bold>
        PELA CONTRATADA:
      </Text>
      <Separator weight={8} />
      <Line color={'black'} />
      <Table center color={'transparent'}>
        <TableRow color={'transparent'}>
          <Text size="small" bold align={'center'}>
            {businessName.toUpperCase()}
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" align={'center'}>
            CNPJ/MF sob o nº {cnpj}
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" italic align={'center'}>
            ({legalRepresentativeName})
          </Text>
        </TableRow>
        <TableRow color={'transparent'}>
          <Text size="small" italic align={'center'}>
            (Assinado eletronicamente)
          </Text>
        </TableRow>
      </Table>

      <Separator weight={8} />

      <Text size="small" bold>
        Testemunhas:
      </Text>
      <Table color={'transparent'} width={'100%'}>
        <TableCol color={'transparent'}>
          <Table color={'transparent'} width={'100%'}>
            <TableRow>
              <Text size="small">1)</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">Nome:</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">CPF:</Text>
            </TableRow>
          </Table>
        </TableCol>
        <TableCol color={'transparent'}>
          <Table color={'transparent'} width={'100%'}>
            <TableRow>
              <Text size="small">2)</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">Nome:</Text>
            </TableRow>
            <TableRow color={'transparent'}>
              <Text size="small">CPF:</Text>
            </TableRow>
          </Table>
        </TableCol>
      </Table>
    </View>
  )
}

export default HRHContent
